import React from 'react'
import PropTypes from 'prop-types'
import TableCell, { tableCellClasses } from '@mui/material/TableCell'
import { TableRow, Typography } from '@mui/material'
import HHDisplayMoney from '../../../common/HHDisplayMoney'

// Helper function to calculate padding multiplier based on hierarchy level
const calculateSubItemLeftPadding = hierarchyLevel => {
  // Base padding is 1 unit (8px in MUI), increase by 1 unit per level
  return (hierarchyLevel || 0) + 1
}

const ChargesTableRow = ({
  service,
  date,
  charge,
  quantity,
  total,
  isSubCharge = false,
  hierarchyLevel = 0,
  serviceCellProps = {},
  serviceCellTypographyProps = {},
}) => {
  const isNotSubcharge = !isSubCharge
  const padding = isSubCharge ? 'none' : 'default'
  const paddingLeft = calculateSubItemLeftPadding(hierarchyLevel)
  const quantityIsOne = parseInt(quantity, 10) === 1
  return (
    <TableRow
      sx={{
        [`& .${tableCellClasses.root}`]: {
          pt: 0,
          pb: 0,
        },
        [`& .${tableCellClasses.root}.${tableCellClasses.paddingNone}`]: {
          pt: 0,
          pb: 0,
        },
      }}
    >
      <TableCell padding={padding} sx={{ pr: 2, ...serviceCellProps }}>
        <Typography
          pl={paddingLeft}
          fontWeight={isNotSubcharge && '600'}
          color="textPrimary"
          overflow="hidden"
          textOverflow="ellipsis"
          whiteSpace="nowrap"
          {...serviceCellTypographyProps}
        >
          {service}
        </Typography>
      </TableCell>
      <TableCell padding={padding}>
        <Typography color="textSecondary">{date}</Typography>
      </TableCell>
      <TableCell padding={padding} align="right">
        <Typography textAlign="right">
          {isNotSubcharge && quantityIsOne && <HHDisplayMoney value={charge} formatToDollars={false} />}
        </Typography>
      </TableCell>
      <TableCell padding={padding} align="right">
        <Typography textAlign="right">{quantity > 0 && quantity}</Typography>
      </TableCell>
      <TableCell padding={padding} align="right">
        <Typography textAlign="right">
          <HHDisplayMoney value={total} formatToDollars={false} />
        </Typography>
      </TableCell>
    </TableRow>
  )
}

ChargesTableRow.propTypes = {
  service: PropTypes.string,
  date: PropTypes.string,
  charge: PropTypes.string,
  quantity: PropTypes.number,
  total: PropTypes.string,
  isSubCharge: PropTypes.bool,
  hierarchyLevel: PropTypes.number,
  serviceCellProps: PropTypes.object,
  serviceCellTypographyProps: PropTypes.object,
}

export default ChargesTableRow
